import { AppsflyerSetUidEvent, NativeEvent } from '~/shared/NativeBridge';

/**
 * Sincroniza o userId interno com o customerUserId do AppsFlyer no
 * shell nativo. Cobre tres casos:
 *   - Login: userId muda de 0 -> id real, dispara setCustomerUserId
 *   - Reload com sessao persistida: auth restaura userId, watcher dispara
 *   - Logout: userId volta a 0, dispatch com string vazia (anonimiza)
 *
 * No-op fora da WebView do app — dispatch retorna false silenciosamente.
 */
export default defineNuxtPlugin(() => {
  if (!NativeEvent.isNativeApp()) {
    return;
  }

  const { userId } = useUserData();

  let lastDispatched: string | null = null;

  const sync = (id: number | string) => {
    const next = String(id ?? '');
    const value = next === '0' ? '' : next;

    if (value === lastDispatched) {
      return;
    }

    new AppsflyerSetUidEvent(value).dispatch();
    lastDispatched = value;
  };

  watch(
    userId,
    (newId) => {
      sync(newId);
    },
    { immediate: true },
  );
});
